import { Ripple } from "primereact/ripple";
import { StyleClass } from "primereact/styleclass";
import { useRef } from "react";
import { Link } from "react-router-dom";
import MeaAvatarDropdown from "./MeaAvatarDropdown";
import { useAuthContext } from "../../hooks/useAuthContext";

const MeaTopNavbar = ({ mainMenu, hideMobileMenu = false }) => {
  const { logout } = useAuthContext();

  const btnRef16 = useRef(null);

  return (
    <div className="surface-section px-3 flex justify-content-between relative lg:static" style={{ minHeight: '60px', borderBottom: '2px solid var(--surface-border)' }}>
      <Link to="/" className="mr-0 lg:mr-6 align-self-center">
        <img src="/mealogo.svg" alt="Logo" height="40" />
      </Link>
      <StyleClass selector="@next" enterFromClassName="hidden" leaveToClassName="hidden" hideOnOutsideClick nodeRef={btnRef16}>
        <a href="#" ref={btnRef16} className={"p-ripple cursor-pointer lg:hidden align-self-center text-700 " + (hideMobileMenu ? "hidden" : "block")}>
          <i className="p-ripple pi pi-bars text-4xl "></i>
          <Ripple />
        </a>
      </StyleClass>
      <div id="mea-main-navigation" className="flex-grow-1 justify-content-between hidden lg:flex absolute lg:static w-full left-0 top-100 z-1 shadow-2 lg:shadow-none surface-overlay">
        {mainMenu}
        <ul className="list-none p-0 m-0 flex lg:align-items-center select-none flex-column lg:flex-row border-top-1 surface-border lg:border-top-none">
          <li className="lg:hidden">
            <Link to="/user/profile" className="no-underline text-color p-ripple border-round-top flex align-items-center px-6 py-3 lg:px-3 lg:py-3 font-medium cursor-pointer transition-colors transition-duration-150 hover:surface-hover">
              <i className="pi pi-inbox text-base lg:text-2xl mr-2 lg:mr-0"></i>
              <span className="block font-medium">Mon profil utilisateur</span>
              <Ripple />
            </Link>
          </li>
          <li className="lg:hidden">
            <Link to="/user/schools" className="no-underline text-color p-ripple border-round-top flex align-items-center px-6 py-3 lg:px-3 lg:py-3 font-medium cursor-pointer transition-colors transition-duration-150 hover:surface-hover">
              <i className="pi pi-home text-base lg:text-2xl mr-2 lg:mr-0"></i>
              <span className="block font-medium">Mes écoles</span>
              <Ripple />
            </Link>
          </li>
          <li className="lg:hidden">
            <Link to="/sys/schools" className="no-underline text-color p-ripple border-round-top flex align-items-center px-6 py-3 lg:px-3 lg:py-3 font-medium cursor-pointer transition-colors transition-duration-150 hover:surface-hover">
              <i className="pi pi-cog text-base lg:text-2xl mr-2 lg:mr-0"></i>
              <span className="block font-medium">Super Admin</span>
              <Ripple />
            </Link>
          </li>
          <li className="lg:hidden">
            <a
              onClick={(e) => {
                e.preventDefault();
                logout();
              }}
              className="no-underline text-color p-ripple border-round-top flex align-items-center px-6 py-3 lg:px-3 lg:py-3 font-medium cursor-pointer transition-colors transition-duration-150 hover:surface-hover"
            >
              <i className="pi pi-sign-out text-base lg:text-2xl mr-2 lg:mr-0"></i>
              <span className="block font-medium">Déconnexion</span>
              <Ripple />
            </a>
          </li>
          <li className="border-top-1 surface-border lg:border-top-none">
            <MeaAvatarDropdown />
          </li>
        </ul>
      </div>
    </div>
  )
}

export default MeaTopNavbar;